import SearchOptions from './SearchOptions';

interface Part {
    words: string[];
}

export default class SearchQuery {

    private parts: Part[];

    public constructor(private readonly text: string, private readonly options: SearchOptions) {
    }

    public getText(): string {
        return this.text;
    }

    public getOptions(): SearchOptions {
        return this.options;
    }

    public getParts(): Part[] {
        if (this.parts) {
            return this.parts; // Return cached parts.
        }

        const textParts = [];

        // Find all double quoted search terms and add each as a part.
        const partRegex = /"(.+?)"/g;
        let partMatch = partRegex.exec(this.text);
        while (partMatch !== null) {
            textParts.push(partMatch[1].trim());
            partMatch = partRegex.exec(this.text);
        }

        // Remove all quoted search terms and add each remaining word as a separate part.
        const noQuotedParts = this.text.replace(/".+?"/g, '');
        const wordParts = noQuotedParts.split(' ').filter(part => part !== '');
        textParts.push(...wordParts);

        const parts = [];
        for (const textPart of textParts) {
            parts.push({
                words: textPart.split(' ')
            });
        }
        return this.parts = parts;
    }
}
